// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__10f8l","error":"Textarea_error__crn-g","readonly":"Textarea_readonly__17Cw7","disabled":"Textarea_disabled__3Sggf"};